import { client } from "@/services";
import Vue from "vue";
import config from "@/config";

const venuesService = client.service("venues");
const venues = {
	namespaced: true,
	state: {
		venues: [],
		venue: {},
	},
	getters: {
		GET_VENUES: (state) => state.venues,
		GET_VENUE: (state) => state.venue,
	},
	mutations: {
		SET_VENUES(state, venues) {
			state.venues = venues;
		},
		SET_VENUE(state, venue) {
			state.venue = { ...venue };
		},
		ADD_VENUE(state, venue) {
			state.venues.push(venue);
		},
		UPDATE_VENUE(state, venue) {
			const venueIndex = state.venues.findIndex(
				(stateVenue) => stateVenue._id === venue._id
			);

			//reactivity hack
			if (venueIndex != -1) {
				Vue.set(state.venues, venueIndex, venue);
			}
		},
		DELETE_VENUE(state, venueId) {
			const venueIndex = state.venues.findIndex(
				(stateVenue) => stateVenue._id === venueId
			);

			state.venues.splice(venueIndex, 1);
		},
	},
	actions: {
		async GET_VENUE({ commit }, venueId) {
			const venue = await venuesService.get(venueId);

			commit("SET_VENUE", venues);

			return venue;
		},
		async GET_VENUES({ commit }, filter) {
			const venues = await venuesService.find({
				query: {
					$paginate: {
						value: false,
					},
				},
			});

			commit("SET_VENUES", venues);

			return venues;
		},
		async ADD_VENUE({ commit }, payload) {
			try {
				const sameVenueName = await venuesService.find({
					query: { name: payload.venue.name },
				});

				if (sameVenueName.data.length > 0) {
					throw { message: "Venue Name already been taken!" };
				} else {
					const clone = JSON.parse(JSON.stringify(payload.venue));
					const response = await venuesService.create(clone);

					commit("ADD_VENUE", response);

					return response;
				}
			} catch (error) {
				throw error;
			}
		},
		async UPDATE_VENUE({ commit }, payload) {
			try {
				const clone = JSON.parse(JSON.stringify(payload.venue));
				const response = await venuesService.update(payload.venueId, clone);

				commit("UPDATE_VENUE", response);
				commit("SET_VENUE", response);

				return response;
			} catch (error) {
				throw error;
			}
		},
		async DELETE_VENUE({ commit }, venueId) {
			try {
				const response = await venuesService.remove(venueId);

				commit("DELETE_VENUE", venueId);

				return response;
			} catch (error) {
				throw error;
			}
		},
		
		async uploadLogo({ commit, dispatch }, { file, venueId }) {
			try {
				const formData = new FormData();
				formData.append("logo", file);
				formData.append("venueId", venueId)
				
				const {
					data: { success, message },
				} = await require("axios").post(
					`${config.server_url}/api/upload-venue-logo`,
					formData,
					{
						headers: {
							"Content-Type": "multipart/form-data",
						},
					}
				);

				if (success) {
					await dispatch("editVenue");
				} else {
					throw message;
				}
			} catch (err) {
				throw err;
			}
		},
	},
};

export default venues;


// WEBPACK FOOTER //
// ./src/store/modules/venues.js